import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  subsectionTitle: {
    color: '#1976d2',
    marginTop: '25px',
    marginBottom: '15px',
    fontSize: '16px',
    fontWeight: 600,
  },
}));

const TestSubsection = ({ title, children }) => {
  const classes = useStyles();

  return (
    <>
      <h3 className={classes.subsectionTitle}>{title}</h3>
      {children}
    </>
  );
};

export default TestSubsection;
